export default [
    "24 24",
    '<path id="Vector" d="M3 17H21M3 12H21M3 7H21" fill="none" class="stroke-over" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>']

